<template>
  <v-container class="generalCon">
    <v-card>
      <v-data-table
        :headers="CMheaders"
        :items="creditMemos"
        :items-per-page=-1
        @current-items="filteredItemsCM"
        :search="search"
        class="elevation-1"
        @click:row="onCMRowClick"
        fixed-header
        height="calc(100vh - 120px)"
        :sort-by="CMcurrentSort"
        :sort-desc="CMsortDesc"
        @update:sort-by="CMupdateSort"
        @update:sort-desc="CMupdateSortDesc"
      >
        <template v-slot:top>
          <v-toolbar
            flat
          >
            <v-toolbar-title>Credit Memos</v-toolbar-title><v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <v-btn
              class="mx-1" 
              fab dark small
              elevation="3"
              color="primary"
              @click="openFilter"
            >
              <v-icon dark>
                mdi-filter-multiple
              </v-icon>
            </v-btn>
            <v-btn
              class="mx-1" 
              color="primary" dark 
              elevation="3"
              @click="resetFilters"
            >
              Reset Filters
            </v-btn>
            <v-btn
              class="ml-4" 
              color="primary" dark 
              elevation="3"
              @click="openWorkflowSettings()"
            >
              Workflow Settings
            </v-btn>
          </v-toolbar>
          <v-overlay :value="overlay">
            <v-progress-circular
              :size="70"
              :width="7"
              color="indigo darken-2"
              indeterminate
            ></v-progress-circular>
          </v-overlay>
          <v-dialog
            v-model="openStatusChangeConfirmationPopUp"
            max-width="600px"
            persistent
          >
            <v-card class="pa-4 elevation-3" color="warning lighten-5" outlined>
              <v-card-title class="d-flex align-center">
                <v-icon color="warning" class="mr-3">mdi-alert-circle</v-icon>
                <span class="text-h6 font-weight-medium text-warning">Warning</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="py-4">
                <p class="mb-0 text-body-2">
                  Are you sure you want to move the aging status back to <strong>'No Response'</strong>? This action will reset the Aging CM Workflow.
                </p>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="justify-end">
                <v-btn color="grey darken-1" text @click="cancelConfirmationPopup">
                  Cancel
                </v-btn>
                <v-btn color="warning darken-2" text @click="handleStatusChange">
                  Yes
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        <v-dialog
          v-model="filtersDialog"
          max-width="900px"
          persistent
        >
          <v-card>
            <v-card-title>
              <span class="text-h5">Filters</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col >
                    <v-select
                      v-model="filterOptions.Next_Activity_Owner"
                      :items="Next_Activity_Owner_List"
                      label="Next Activity Owner Name"
                    ></v-select>
                  </v-col>
                  <v-col >
                    <v-select
                      v-model="filterOptions.Aging_Credit_Memo_Status"
                      :items="agingStatuses"
                      label="Aging Credit Memo Status"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col >
                    <v-select
                      v-model="filterOptions.Client"
                      :items="ClientsList"
                      label="Client"
                    ></v-select>
                  </v-col>
                  <v-col >
                    <v-select
                      v-model="filterOptions.Law_Firm"
                      :items="LawFirmsList"
                      label="Law Firm"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="cancel"
              >
                Cancel
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="filters"
              >
                Filter
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        </template>
        <template v-slot:[`item.Activities`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                class="ma-2"
                :color="item.Activity_Color"
                text-color="white"
                label
                v-bind="attrs"
                v-on="on"
                @click="openActivityRecord(item)"
              >
                <v-icon left>{{ item.Activity_Icon }}</v-icon>
                {{ item.Activities }}
              </v-chip>
            </template>
            <span>{{ item.Activity_Text }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.Aging_Credit_Memo_Status`]="{ item }">
          <v-select
            v-model="item.Aging_Credit_Memo_Status"
            :items="agingStatuses"
            clearable
            @click.stop 
            @change='agingStatusChange(item)'
          ></v-select>
        </template>   
        <template v-slot:[`item.CMRecord`]="{ item }">
          <v-btn
            class="ma-2"
            text
            icon
            color="blue"
            @click="openCMRecord(item)"
          >
            <v-icon>mdi-link-variant</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
  export default {
    data(){
      return{
        search:'',
        CMview:true,
        CMheaders: [
        { text: 'Next Activitiy', align: 'center', value: 'Activities'},
        { text: 'Next Activitiy Owner', align: 'center', value: 'Activity_Owner_Name'},
        { text: 'CM Name', align: 'start', value: 'Name'},
        { text: 'Disable Aging WF', align: 'start', value: 'Disable_Aging_CM_Workflow'},
        { text: 'Aging Credit Memo Status', align: 'center', value: 'Aging_Credit_Memo_Status'},
        { text: 'Deadline', align: 'center', value: 'Deadline'},
        { text: 'Client', align: 'start', value: 'Client'},
        { text: 'Law Firm', width:100,align:'center',value: 'LawFirm' },
        { text: 'Bill Count', width:80,align:'center',value: 'BillCount' },
        { text: 'Original Total', width:100,align:'center',value: 'OriginalTotal' },
        { text: 'Current Total Adjustments', width:120,align:'center',value: 'Adjustments' },
        { text: 'Current Adjusted Total', width:110,align:'center',value: 'Final_Total' },
        { text: 'CM Record', width:80,align:'center',value: 'CMRecord' },
        ],
        creditMemos: [],
        creditMemosPast: [],
        selected: [],
        sendCMTitle:"",
        overlay: false,
        CMcurrentSort: 'Activity_Date',
        CMsortDesc: false,
        agingStatuses: ["No response","LF has acknowledged receipt","LF intends to appeal","LBR Action Needed","Law Firm Action Needed","Long Term Unresponsive",""],
        filtersDialog: false,
        filterOptions: {
          "Next_Activity_Owner":null,
          "Aging_Credit_Memo_Status":null,
          "Client":null,
          "Law_Firm":null
        },
        Next_Activity_Owner_List: [],
        ClientsList:[],
        LawFirmsList:[],
        openStatusChangeConfirmationPopUp: false,
        currentCMRecord: {}
      }
    },
    mounted(){
      this.getAllCreditMemos();
    },
    watch:{
    
    },
    methods: {
      async getAllCreditMemos (){
        const that = this;
        that.overlay = true;
        that.creditMemos=[];
        that.creditMemosPast=[];
        that.CMview=true;
        that.ClientsList=[];
        that.LawFirmsList=[];
        that.Next_Activity_Owner_List=[];
        try {
          await ZOHO.embeddedApp.init()
            .then(function() {
                ZOHO.CRM.CONFIG.getCurrentUser().then(async function(currentUserData){
                //console.log(currentUserData);
                let currentUserMap=currentUserData.users[0];
                let currentUser=currentUserMap.id;  
                let NumCM;
                let page=1;
                //
                //-----------------------------------------------------------------------------------------------------------------------------------------------------------------
                do {
                  let CMdata = {};
                  //   
                  CMdata= await ZOHO.CRM.API.searchRecord({Entity:"Credit_Memos",Type:"criteria",Query:"(Status:equals:Initial CM Sent to LF)",page:page,per_page:200});
                  //console.log("CMdata:", CMdata);
                  //     
                  if(CMdata.statusText!="No Content" && CMdata.statusText!="nocontent"){
                    let allCM=CMdata.data;
                    NumCM=allCM.length;
                    page++;
                    for (let i = 0; i < allCM.length; i++) {
                      const CMemos = allCM[i];
                      console.log("CMemos",CMemos);
                      let dollarUS = Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                      });
                      let Original_Total=CMemos.Original_Total==null ? "" : CMemos.Original_Total.toFixed(2);
                      let BillCompensation=Original_Total=="" ? "" : (Original_Total*.005).toFixed(2);
                      let CMRecords={
                        table:"Credit Memo",
                        id:CMemos.id==null ? "" : CMemos.id,
                        Name: CMemos.Name==null ? "" : CMemos.Name,
                        Client: CMemos.Client==null ? "" : CMemos.Client.name,
                        ClientID: CMemos.Client==null ? "" : CMemos.Client.id,
                        LawFirm: CMemos.Law_Firm==null ? "" : CMemos.Law_Firm.name,
                        LawFirmID: CMemos.Law_Firm==null ? "" : CMemos.Law_Firm.id,
                        BillCount: CMemos.Total_Related_Bills==null ? "" : CMemos.Total_Related_Bills,
                        OriginalTotal: dollarUS.format(Original_Total),
                        Adjustments: CMemos.Final_Adjustments==null ? "" : dollarUS.format(CMemos.Final_Adjustments.toFixed(2)),
                        AddAdjustment: CMemos.Additional_Adjustment==null ? "" : dollarUS.format(CMemos.Additional_Adjustment.toFixed(2)),
                        Final_Total: CMemos.Final_Adjusted_Total==null ? "" :dollarUS.format(CMemos.Final_Adjusted_Total.toFixed(2)),
                        BillCompensation:dollarUS.format(BillCompensation),
                        Status: CMemos.Status==null ? "" : CMemos.Status,
                        recipientID: CMemos.Law_Firm_Contact==null ? "" : CMemos.Law_Firm_Contact.id,
                        recipient: CMemos.Law_Firm_Contact==null ? "" : CMemos.Law_Firm_Contact.name,
                        Activities: "Loading...",
                        Latest_Activity_Type: null,
                        Activity_Color: "blue",
                        Activity_ID: null,
                        Activity_Icon: null,
                        Aging_Credit_Memo_Status: CMemos.Aging_Credit_Memo_Status==null ? "" : CMemos.Aging_Credit_Memo_Status,
                        Activities: "Loading...",
                        Activity_Date: CMemos.Next_schedule_call_date=="" ? new Date('1999-09-17') : CMemos.Next_schedule_call_date,
                        Latest_Activity_Type: CMemos.nextActivityType,
                        Activity_ID: CMemos.nextActivityID,
                        Activity_Icon: null,
                        Activity_Color: "blue",
                        Activity_Text: CMemos.nextActivityText,
                        Disable_Aging_CM_Workflow: CMemos.Disable_Aging_CM_Workflow == "" ? "NO" : "YES",
                        Activity_Owner_Name: CMemos.Next_Activity_Owner == null ? "" : CMemos.Next_Activity_Owner,
                        Deadline: CMemos.Second_Level_target_negotiation_end_date==null ? "" : CMemos.Second_Level_target_negotiation_end_date
                      };
                      //
                      if(CMRecords.Client!=""){
                        let clientRec={
                          text: CMRecords.Client,
                          value: CMRecords.Client,
                        };
                        that.ClientsList.push(clientRec);
                        // Sort ClientsList alphabetically by the 'text' property
                        that.ClientsList.sort((a, b) => a.text.localeCompare(b.text));
                      }
                      if(CMRecords.LawFirm!=""){
                        let lawFirmRec={
                          text: CMRecords.LawFirm,
                          value: CMRecords.LawFirm,
                        };
                        that.LawFirmsList.push(lawFirmRec);
                        // Sort LawFirmsList alphabetically by the 'text' property
                        that.LawFirmsList.sort((a, b) => a.text.localeCompare(b.text));
                      }
                      if(CMRecords.Activity_Owner_Name!=""){
                        let ownerRec={
                          text: CMRecords.Activity_Owner_Name,
                          value: CMRecords.Activity_Owner_Name,
                        };
                        that.Next_Activity_Owner_List.push(ownerRec);
                      }
                      //
                      //--------------------------------------------------------------------------------------------------------------
                      // CM NEXT ACTIVITY COLUMN
                      if (CMRecords.Latest_Activity_Type == "Calls") {
                          CMRecords.Activity_Icon = "mdi-phone";
                      } else if (CMRecords.Latest_Activity_Type == "Events") {
                          CMRecords.Activity_Icon = "mdi-calendar-check";
                      } else if (CMRecords.Latest_Activity_Type == "Tasks") {
                          CMRecords.Activity_Icon = "mdi-checkbox-marked-circle";
                      }

                      if (CMRecords.Activity_ID !== null) {
                          let nextActivityDateFormat;
                          let activityColor;

                          // Extract the date portion from CMRecords.Activity_Date (YYYY-MM-DD)
                          let nextActivityDateStr = CMRecords.Activity_Date.substring(0, 10);  // Get 'YYYY-MM-DD'

                          // Get the current UTC date in 'YYYY-MM-DD' format
                          let currentDateObj = new Date();
                          let currentDateStr = new Date(currentDateObj.getTime() - currentDateObj.getTimezoneOffset() * 60000).toISOString().substring(0, 10);  // Convert to UTC and format 'YYYY-MM-DD'

                          // Log the current date and activity date for debugging
                          //console.log("currentDateStr",currentDateStr);
                          //console.log("CMRecords.Activity_Date",CMRecords.Activity_Date);

                          if (nextActivityDateStr === currentDateStr) {
                              nextActivityDateFormat = "TODAY";
                              activityColor = "orange";
                          } else if (nextActivityDateStr > currentDateStr) {
                              // Manually format nextActivityDateStr to 'MMM DD' (e.g., 'SEP 19')
                              let [year, month, day] = nextActivityDateStr.split("-");
                              let months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
                              nextActivityDateFormat = `${months[parseInt(month, 10) - 1]} ${parseInt(day, 10)}`;
                              activityColor = "green";
                          } else if (nextActivityDateStr < currentDateStr) {
                              // Manually format nextActivityDateStr to 'MMM DD' (e.g., 'SEP 19')
                              let [year, month, day] = nextActivityDateStr.split("-");
                              let months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
                              nextActivityDateFormat = `${months[parseInt(month, 10) - 1]} ${parseInt(day, 10)}`;
                              activityColor = "red";
                          }

                          // Log the next activity date and color for debugging
                          //console.log("nextActivityDateObj", nextActivityDateStr);
                          CMRecords.Activities = nextActivityDateFormat;
                         //console.log("nextActivityDateFormat: " + nextActivityDateFormat);

                          CMRecords.Activity_Color = activityColor;
                          //console.log("Activity Color: " + activityColor);

                          //--------------------------------------------------------------------------------------------------------------
                          /*await ZOHO.CRM.API.getRecord({
                          Entity: "Tasks", approved: "both", RecordID:CMemos.nextActivityID
                          })
                          .then(function(data){
                              console.log(data.data[0].Owner.name);
                              CMRecords.Activity_Owner_Name = data.data[0].Owner.name;
                              //
                              if(CMRecords.Activity_Owner_Name!=""){
                                let ownerRec={
                                  text: CMRecords.Activity_Owner_Name,
                                  value: CMRecords.Activity_Owner_Name,
                                };
                                that.Next_Activity_Owner_List.push(ownerRec);
                              }
                              //
                          })*/
                          //--------------------------------------------------------------------------------------------------------------

                      } else {
                          // If no upcoming activities
                          //console.log("No upcoming activities.");
                          //console.log("Activity Color: gray");

                          CMRecords.Activities = "No upcoming activities.";
                          CMRecords.Activity_Color = "gray";
                      }
                      //--------------------------------------------------------------------------------------------------------------
                      that.creditMemos.push(CMRecords);
                      that.creditMemosPast.push(CMRecords);
                      //console.log(CMRecords);
                    }
                  }
                } while (NumCM==200);
                //console.log("that.creditMemos",that.creditMemos);
                //End loader.
                that.overlay = false;
              });
            })
            .catch(function(err) {
              console.log(err);
              //
              let func_name = "sendWidgetErrorNotfication";
                let req_data ={
                  "arguments": JSON.stringify({
                      "subject" : 'ERROR ON LOADING CMs [Negotiation Widget]',
                      "message" : err
                  })
                };
                ZOHO.CRM.FUNCTIONS.execute(func_name, req_data)
            })
        }catch (err) {
           //
           let func_name = "sendWidgetErrorNotfication";
            let req_data ={
              "arguments": JSON.stringify({
                  "subject" : 'ERROR ON LOADING CMs [Negotiation Widget]',
                  "message" : err
              })
            };
            ZOHO.CRM.FUNCTIONS.execute(func_name, req_data)
        }
      },
      onCMRowClick(CMRecord){
      },
      CMupdateSort(newSort){
        this.CMcurrentSort = newSort;
      },
      CMupdateSortDesc(newSortDesc) {
        this.CMsortDesc = newSortDesc;
      },
      filteredItemsCM(val){
        this.TotItemsCMFiltered=[...val]
      },
      openActivityRecord(CMRecord){
        if(CMRecord.Activities != "No upcoming activities."){
          this.openCMRecView=true;
          let openLink='https://crm.zoho.com/crm/org707264060/tab/' + CMRecord.Latest_Activity_Type + '/' + CMRecord.Activity_ID;
          window.open(openLink, '_blank').focus();
          setTimeout(() => {
            this.openCMRecView = false;
          }, 2000);
        }
        else{
          this.openCMRecord(CMRecord);
        }
      },
      openCMRecord(val){
        this.openCMRecView=true;
        let openLink='https://crm.zoho.com/crm/org707264060/tab/CustomModule14/'+val.id;
        window.open(openLink, '_blank').focus();
        setTimeout(() => {
          this.openCMRecView = false;
        }, 2000);
      },
      agingStatusChange(CMRecord){
        this.currentCMRecord = CMRecord;
        //
        if(CMRecord.Aging_Credit_Memo_Status == "No response" && CMRecord.Disable_Aging_CM_Workflow == "NO"){
          this.openStatusChangeConfirmationPopUp = true;
        }
        else{
          this.updateAgingCMStatus();
        }
      },
      handleStatusChange() {
        this.openStatusChangeConfirmationPopUp = false; // Close the popup
        this.updateAgingCMStatus(); // Call the existing method
      },
      updateAgingCMStatus(){
        let config={
          Entity:"Credit_Memos",
            APIData:{
              "id": this.currentCMRecord.id,
              "Aging_Credit_Memo_Status": this.currentCMRecord.Aging_Credit_Memo_Status
            }
          }
        ZOHO.CRM.API.updateRecord(config)
        .then(function(data){
          console.log("updateRecord",data)
        })
      },
      openWorkflowSettings(){
        let openLink='https://crm.zoho.com/crm/org707264060/tab/CustomModule58/custom-view/4372928000144280373/list?page=1';
        window.open(openLink, '_blank').focus();
        setTimeout(() => {
          this.openCMRecView = false;
        }, 2000);
      },
      async openFilter(){
        this.filtersDialog = true;
      },
      resetFilters(){
        this.filtersDialog=false;
        this.filterOptions = {
          "Next_Activity_Owner":null,
          "Aging_Credit_Memo_Status":null,
          "Client":null,
          "Law_Firm":null
        };
        this.creditMemos=this.creditMemosPast;
      },
      cancel(){
        this.filtersDialog = false;
        this.filterOptions = {
          "Next_Activity_Owner":null,
          "Aging_Credit_Memo_Status":null,
          "Client":null,
          "Law_Firm":null
        };
      },
      cancelConfirmationPopup(){
        this.openStatusChangeConfirmationPopUp = false;
        this.currentCMRecord = {};
        this.getAllCreditMemos();
      },
      filters(){
        let cont=true;
        let newCM=[];
        //
        if(this.filterOptions.Client!==null){
          let newArr=[];
          if(newCM.length>0){
            newArr=newCM.filter(this.CM_Client_Func);
            newCM=[];
          }else{
            newArr=this.creditMemosPast.filter(this.CM_Client_Func);
          }
          if(newArr.length==0){cont=false;}
          if(cont){
            for (let i = 0; i < newArr.length; i++) {
              const element = newArr[i];
              newCM.push(element);
            }
          }
        }
        if(this.filterOptions.Law_Firm!==null){
          let newArr=[];
          if(newCM.length>0){
            newArr=newCM.filter(this.CM_LawFirm_Func);
            newCM=[];
          }else{
            newArr=this.creditMemosPast.filter(this.CM_LawFirm_Func);
          }
          if(newArr.length==0){cont=false;}
          if(cont){
            for (let i = 0; i < newArr.length; i++) {
              const element = newArr[i];
              newCM.push(element);
            }
          }
        }
        if(this.filterOptions.Next_Activity_Owner!==null){
          let newArr=[];
          if(newCM.length>0){
            newArr=newCM.filter(this.CM_Next_Activity_Owner_Func);
            newCM=[];
          }else{
            newArr=this.creditMemosPast.filter(this.CM_Next_Activity_Owner_Func);
          }
          if(newArr.length==0){cont=false;}
          if(cont){
            for (let i = 0; i < newArr.length; i++) {
              const element = newArr[i];
              newCM.push(element);
            }
          }
        }
        console.log("this.filterOptions.Aging_Credit_Memo_Status",this.filterOptions.Aging_Credit_Memo_Status)
        if(this.filterOptions.Aging_Credit_Memo_Status!==null){
          let newArr=[];
          if(newCM.length>0){
            newArr=newCM.filter(this.CM_Aging_Credit_Memo_Status_Func);
            newCM=[];
          }else{
            newArr=this.creditMemosPast.filter(this.CM_Aging_Credit_Memo_Status_Func);
          }
          if(newArr.length==0){cont=false;}
          if(cont){
            for (let i = 0; i < newArr.length; i++) {
              const element = newArr[i];
              newCM.push(element);
            }
          }
        }
        //
        this.creditMemos = newCM;
        this.filtersDialog = false;
      },
      CM_Client_Func(element){
        return element.Client===this.filterOptions.Client ? true: false;
      },
      CM_LawFirm_Func(element){
        return element.LawFirm===this.filterOptions.Law_Firm ? true: false;
      },
      CM_Next_Activity_Owner_Func(element){
        return element.Activity_Owner_Name===this.filterOptions.Next_Activity_Owner ? true: false;
      },
      CM_Aging_Credit_Memo_Status_Func(element){
        return element.Aging_Credit_Memo_Status===this.filterOptions.Aging_Credit_Memo_Status ? true: false;
      },
    }
  }
</script>
<style>
.generalCon{
  background-color: transparent;
  padding: 0 !important;
}
.container {
  max-width: none !important;
}
tbody>tr:hover {
  cursor: pointer;
}

.v-progress-circular {
  margin: 1rem;
}
.explanation{
  font-size: 12px;
}
.narrativeClassText{
  font-size: 0.75rem !important;
}
.headerClass{
  font-size: 0.75rem !important;
}
.columnWidth{
  width: 150px;
}
.tableMarg{
  padding-right: 20px;
}

.statsHeaders{
  font-size: 1.2rem ;
  font-weight: bold;
  margin-bottom: 0 !important;
}
.statsText{
  font-size: 1.2rem ;
}
.v-text-field__details{
  display: none !important;
}
.highlight-mismatch {
  color: red;
}
.floating-close {
  position: fixed;
  bottom: 15px;  /* Adjust vertical position */
  right: 38px;  /* Adjust horizontal position */
  z-index: 9999;
}
</style>